import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconQuestionCircleFill';
/** Renders an SVG icon. */
const SvgQuestionCircleFill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14S23.732 2 16 2m-1 9.5a1.5 1.5 0 0 0-1.5 1.5 1.5 1.5 0 0 1-3 0A4.5 4.5 0 0 1 15 8.5h1.576a4.54 4.54 0 0 1 3.488 1.633l.073.088a4.4 4.4 0 0 1 .055 5.565 6.1 6.1 0 0 1-1.635 1.43l-.499.299a1.15 1.15 0 0 0-.558.985 1.5 1.5 0 0 1-3 0 4.15 4.15 0 0 1 2.015-3.558l.498-.3c.32-.191.603-.439.837-.73a1.4 1.4 0 0 0-.018-1.77l-.073-.088a1.54 1.54 0 0 0-1.183-.554zm2.5 11a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
      />
    </svg>
  );
};
SvgQuestionCircleFill.displayName = displayName;
export default SvgQuestionCircleFill;
